module.exports = __webpack_public_path__ + "front/img/p20.d430b81e.png";